<div class="modal-content">
  <div class="modal-body">
    <h2 class="modal-title">Ajustes en el contrato</h2>
    <p class="body-text">
      Te informamos que hemos realizado algunos ajustes en nuestro contrato de servicios. Estos cambios entrarán en
      vigencia a partir del 21 de enero del 2026. <br />
      Puedes revisar el contrato actualizado haciendo clic en el enlace a continuación:
    </p>

    <a [href]="contractUrl" class="contract-link" (click)="onLinkClick($event)">Ver contrato actualizado</a>
  </div>
  <div class="footer">
    <p class="footer-text">
      Al continuar utilizando nuestros servicios, estarás aceptando automáticamente los términos del nuevo contrato.
    </p>

    <fs-ui-button [action]="'submit'" (click)="close()" [label]="'Cerrar'"> </fs-ui-button>
  </div>
</div>
